// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__C5xav","name":"Header_name__14-WH","birthday":"Header_birthday__3TT-6","skeleton":"Header_skeleton__3ltTs"};